<template>
  <tbody>
  <tr :class="[{more_info: isEditable && $_updateActionAllowed}, { open: isOpen }, {disabled: !isEditable}]" @click="triggerIfEditable">
    <td :data-th="'Protokol' | translate" class="first_data">{{ itemProtocolName }}</td>
    <td :data-th="'Template URL' | translate">{{ item.template }}</td>
    <td :data-th="'DRM license URL template' | translate">{{ item.drm_license_url_template }}</td>
    <td :data-th="'DRM certificate URL template' | translate">{{ item.drm_certificate_url_template }}</td>
    <td :data-th="'Adaptivní obsah' | translate">
      <img
          class="is_set"
          src="../../../assets/images/is-set.svg"
          :alt="'Ano' | translate"
          v-if="item.adaptive">
    </td>
    <td class="no_padding edit">
      <div class="edit_inner" v-if="isEditable">
        <a
            v-if="$_updateActionAllowed"
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.stop.prevent="deleteLinearContent"
            v-translate>Smazat
        </a>
      </div>
    </td>
  </tr>
  <tr :class="['more_info_content', { open: isOpen }]">
    <td class="first_data">
      <select-box
          :id="idProtocol"
          v-model="editedItem.id_protocol"
          :options="protocolOptions">
        <translate>Protokol</translate>
      </select-box>
    </td>
    <td>
      <textarea-input
          :id="idTemplate"
          v-model="editedItem.template"
          :ref="item.id + '-templateref'">
        <translate>Template URL</translate>
      </textarea-input>
    </td>
    <td>
      <textarea-input
          :id="idDrmLicenseUrlTemplate"
          v-model="editedItem.drm_license_url_template">
        <translate>DRM license URL template</translate>
      </textarea-input>
    </td>
    <td>
      <textarea-input
          :id="idDrmCertificateUrlTemplate"
          v-model="editedItem.drm_certificate_url_template">
        <translate>DRM certificate URL template</translate>
      </textarea-input>
    </td>
    <td>
      <checkbox-input
          :id="idAdaptive"
          p-class="field checkbox"
          :with-submit="true"
          @submit="updateLinearContent"
          v-model="editedItem.adaptive">
        <translate>Adaptivní obsah</translate>
      </checkbox-input>
    </td>
    <td><p></p></td>
  </tr>
  </tbody>
</template>

<script>
import {getTextByValue} from "@/utils/helpers"
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "LinearContentRow",
  mixins: [requiredFields],
  created() {
    this.editedItem = this._.pick(this.item, this.keysToPick)
  },
  data() {
    return {
      isOpen: false,
      editedItem: {
        id_protocol: null,
        template: null,
        drm_license_url_template: null,
        drm_certificate_url_template: null,
        adaptive: null,
      },
      keysToPick: [
        'id',
        'id_protocol',
        'template',
        'drm_license_url_template',
        'drm_certificate_url_template',
        'adaptive',
      ],
    }
  },
  props: {
    item: Object,
    isEditable: Boolean,
    protocolOptions: Array,
  },
  computed: {
    itemProtocolName() {
      return getTextByValue(this.protocolOptions, this.item.id_protocol)
    },
    idProtocol() {
      return 'edit-linear-protocol-' + this.item.id
    },
    idTemplate() {
      return 'edit-linear-template-' + this.item.id
    },
    idDrmLicenseUrlTemplate() {
      return 'edit-linear-drm-license-url-template-' + this.item.id
    },
    idDrmCertificateUrlTemplate() {
      return 'edit-linear-drm-certificate-url-template-' + this.item.id
    },
    idAdaptive() {
      return 'edit-linear-adaptive-' + this.item.id
    }
  },
  methods: {
    updateLinearContent() {
      this.$emit('submit', {...this.editedItem})
    },
    deleteLinearContent() {
      this.$emit('delete', this.item.id)
    },
    triggerIfEditable() {
      if (this.isEditable && this.$_updateActionAllowed) {
        this.isOpen = !this.isOpen
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/LinearContentRow.vue